import axios from "../plugins/axios.plugin";

class PublicShipperService {
  baseServicePath = "/api/public/shipper";

  getAllPublicShippers() {
    return axios.get(`${this.baseServicePath}/index?properties=1&page=1`);
  }
  filterPublicShipper(payload, page) {
    return axios.post(
      `${this.baseServicePath}/filter/index?page=${page}`,
      payload
    );
  }
  filterShipperNoPage(payload) {
    return axios.post(
      `${this.baseServicePath}/filter/index?pagination=0`,
      payload
    );
  }
  storeShipper(payload) {
    return axios.post(`${this.baseServicePath}/store`, payload);
  }
  searchShipper(payload) {
    return axios.post(`${this.baseServicePath}/search/index`, payload);
  }
  showAShipper(payload) {
    return axios.get(`${this.baseServicePath}/show?id=${payload}&properties=1`);
  }
  showMyShipper(payload) {
    return axios.get(`${this.baseServicePath}/me?properties=1`, payload);
  }
  editShipper(payload) {
    return axios.post(`${this.baseServicePath}/update`, payload);
  }
  deleteShipper(payload) {
    return axios.post(`${this.baseServicePath}/delete`, payload);
  }
  approveShipper(payload) {
    return axios.post(`${this.baseServicePath}/approve/management`, payload);
  }
  unapproveShipper(payload) {
    return axios.post(`${this.baseServicePath}/unapprove/management`, payload);
  }
}
export const publicShipperService = new PublicShipperService();
